
const PanelSeparator = ({className}) => {
  return (
    <div className={`PanelSeparator ${className}`}/>
  );
};

export default PanelSeparator;
